define (require) ->

  class BaseManager

    _instance: null

    # ----------------------------

    # make Singleton
    @getInstance: ->
      @_instance = new @ if not @_instance?
      @_instance




// WEBPACK FOOTER //
// ./coffee/base/base-manager.coffee